import { Masks } from "@hooks/functions/Masks/Masks";
import { getBiggestValidValue } from "@hooks/functions/Raffle/results";

export function RaffleDefaultNumberHowItWorksDrawLottery() {
  const masks = new Masks();

  const examples: { result: number; limit: number }[] = [
    { result: 67063, limit: 100 },
    { result: 163571, limit: 580 },
    { result: 357379, limit: 50 },
    { result: 185325, limit: 300 },
    { result: 104206, limit: 100 },
  ];

  return (
    <>
      <div className="col-md-12">
        <div className="border rounded p-3 bg-light">
          <h5 className="fw-bold mb-2">Sorteio pela Loteria Federal.</h5>
          <p className="mb-0">
            O sorteio pela Loteria Federal é utilizado para dar mais
            transparência ao processo, pois o número vencedor se baseia em um
            resultado externo e não manipulável pela plataforma.
          </p>
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <h5 className="fw-bold">Como funciona?</h5>
        <ul className="d-flex flex-column gap-2 mb-0">
          <li>
            Uma combinação da Loteria Federal é usada como referência para
            encontrar o ticket vencedor da campanha.
          </li>
          <li>
            Normalmente utilizamos a <strong>5ª combinação</strong>, mas essa
            informação deve estar clara na descrição da campanha.
          </li>
          <li>
            Como o resultado da Loteria Federal pode ser maior do que a
            quantidade de tickets da campanha, o sistema ajusta o número até
            encontrar o maior valor possível dentro do total de tickets
            disponíveis.
          </li>
        </ul>
      </div>

      <div className="col-md-12 mt-3">
        <h5 className="fw-bold">Exemplos</h5>
        <div className="row g-2">
          {examples.map((example) => {
            const winner = getBiggestValidValue(example.result, example.limit);

            return (
              <div
                className="col-md-6 col-xl-4"
                key={`${example.result}-${example.limit}`}
              >
                <div className="border rounded p-3 h-100">
                  <div className="small text-muted">Resultado da Loteria</div>
                  <div className="fw-bold">
                    {masks.formatMilhar(example.result)}
                  </div>
                  <div className="small text-muted mt-2">
                    Total de tickets da campanha
                  </div>
                  <div className="fw-bold">{example.limit}</div>
                  <div className="small text-muted mt-2">Ticket vencedor</div>
                  <div className="fs-5 fw-bold text-success">
                    {masks.formatMilhar(winner)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <div className="border rounded p-3">
          <p>
            Então, se o resultado da Loteria Federal for{" "}
            <strong>091.984</strong> e a campanha tiver{" "}
            <strong>100 tickets</strong>, o número válido será{" "}
            <strong>84</strong>. O ganhador será quem adquiriu o ticket de
            número <strong>84</strong>.
          </p>
          <p>
            Caso o número encontrado não tenha sido vendido, o sistema tenta o
            próximo número válido removendo o primeiro dígito. Exemplo: se o
            resultado válido seria <strong>71</strong>, mas o ticket{" "}
            <strong>71</strong> não foi vendido, o sistema tenta o ticket{" "}
            <strong>1</strong>.
          </p>
          <p className="mb-0">
            Se nenhum dos números derivados do resultado estiver vendido, o
            sistema realiza um sorteio aleatório somente entre os tickets
            vendidos da campanha.
          </p>
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <p className="mb-0">
          Caso haja qualquer dúvida, entre em contato com o nosso Suporte.
        </p>
      </div>
    </>
  );
}
